import { render } from "./EditPreferencesThird.vue?vue&type=template&id=0a5d1bd3&scoped=true"
import script from "./EditPreferencesThird.vue?vue&type=script&lang=js"
export * from "./EditPreferencesThird.vue?vue&type=script&lang=js"

import "./EditPreferencesThird.vue?vue&type=style&index=0&id=0a5d1bd3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5d1bd3"]])

export default __exports__